import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { query, where, getDocs, collection } from "firebase/firestore";
//import { db } from "../firebase";  
import Cookies from 'js-cookie';
//page links   
import './footer.css';
import GooglePlayIcon from '../assets/android-app_v1.png';
import Appstore from '../assets/ios-app_v1.png';
import { BsYoutube } from 'react-icons/bs';
import Save_inquary from './save_inquary';
export default function Footers() {
  const navigate = useNavigate();
  const location = useLocation();
  const [Jobtasks, setJobtasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [rowCounts, setRowCounts] = useState({
    users: 0,
    postdata: 0,
    companys: 0,
    total: 0
  });

  

  return (
    <div className="footer-body items-back-fill">

      <div className="container_size">
        <div className='post-container'>
          <div className='post_div'>
            <div className='ui-grid-2item'>
              <div className='ui-items'>
                <table  >
                  <tr>
                    <td>
                      <div className="logo-name"><b>Aooz</b>.com</div>
                    </td>
                  </tr>
                  {Cookies?.get("State") && (
                    <tr>
                      <td>
                        <div className="country-name">
                          {Cookies.get("State") + " / " + Cookies.get("Country")}
                        </div>
                      </td>
                    </tr>
                  )}

                  <tr>
                    <td>
                      <a className="tab-link" onClick={() => navigate('/support')}>Help & Support</a>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a className="tab-link" title='About' href='/about'>About Us</a>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <div className="social-icons">
                        {/* <BsInstagram title='Follow on Instagram' onClick={() => window.open('https://www.instagram.com/kangdesk', '_blank')} /> */}

                        {/* <BsFacebook onClick={() => window.open('https://www.facebook.com/editortask', '_blank')} /> */}
                        {/* <BsYoutube title='Subscribe on YouTube' onClick={() => window.open('https://www.youtube.com/@kangdesk?sub_confirmation=1', '_blank')} /> */}
                        {/* <BsLinkedin />
      <BsX /> */}
                      </div>
                    </td>
                  </tr>
                </table>
                <table >

                  <tr>
                    <td>
                      <a className="tab-link" title='App dwonload' href='/install-app'>Directly on our app.</a>
                    </td>
                  </tr>
                  <tr>
                    <td onClick={() => navigate('/install-app')}>
                      <img alt='Editortask Android app' title='Android app' src={GooglePlayIcon} className="app-img" />
                    </td>
                  </tr>
                  <tr>
                    <td onClick={() => navigate('/install-app')}>
                      <img alt="Editortask iOS app" title='iOS app' src={Appstore} className="app-img" />
                    </td>
                  </tr>
                </table>
              </div>

     

              <div className='ui-items'>
                <table >
                  <tr>

                    <td>
                      <div className="tab-title text-h2">For Business</div>
                    </td>
                  </tr>
                  {/* <tr>
                    <td>
                      <a className="tab-link text-h3" title='Typing master' href='/price'>Price</a>
                    </td>
                  </tr> */}
                  <tr>
          <tr><td><a className="tab-link text-h3" title='Services' href='/seller'>Seller</a></td></tr>
                  </tr>
                  <tr>
                    <td><a className="tab-link text-h3" title='Advertisement' href='/advertisement'>Advertisement</a></td>
                  </tr>
                  <tr>
                    <td><a className="tab-link text-h3" title='product seo' href='/product-seo'>Product seo</a></td>
                  </tr>

                  <tr>
                    <td>

                    </td>
                  </tr>
                </table>
              </div>
                       <div className='ui-items'>
                <table >
                  <tr>
                    <td>
                      <div className="tab-title text-h2" >Quick link</div>
                    </td>
                  </tr>
                  <tr><td><a className="tab-link text-h3" title='Services' href='/seller'>Seller</a></td></tr>


                </table>
              </div>
              <div className='ui-items'>
                <table >
                  <tr>

                    <td>
                      <div className="tab-title text-h2">Follow Us</div>
                    </td>
                  </tr>
                  <tr><td><a className="tab-link text-h3" title='Instagram' href='https://www.instagram.com/aoozwebsite'  >Instagram</a></td></tr>
                  <tr><td><a className="tab-link text-h3" title='Youtube' href='https://www.youtube.com/@aoozwebsite'  >Youtube</a></td></tr>
                  <tr><td><a className="tab-link text-h3" title='Facebook' href='https://www.facebook.com/aoozwebsite'  >Facebook</a></td></tr>
                  <tr><td><a className="tab-link text-h3" title='Whatsapp' href='https://whatsapp.com/channel/0029VaA6jUZDTkJwMxKZjm41'  >Whatsapp</a></td></tr>
                  <tr><td><a className="tab-link text-h3" title='Google Reviews' href='https://share.google/0JPjq5OBaaXlWqZde'  >Google Reviews</a></td></tr>

                  <tr>
                    <td>

                    </td>
                  </tr>
                </table>
              </div>
            </div>

          </div>
          <div className='post_updates'>
            <div >
              <table   >
                <tr>
                  <td>
                    <div className="tab-title text-h2">Contact Us</div>
                  </td>
                </tr>
                <tr>
                  <td>

                    <a className="tab-link text-h3" href='https://wa.me/919530621728?text=Hello%20I%20am%20interested' title='Partners'  >Sales : <a className='text-h3'>+91-9530621728</a> <a className='green bold' >Whatsapp</a></a>
                  </td>
                </tr>
                <tr>
                  <td>

                    <a className="tab-link text-h3" href='https://wa.me/918872888728?text=Hello%20I%20am%20support' title='Partners'  >Support : <a className='text-h3'>+91-8872888728</a> <a className='green bold text-h3' >Whatsapp</a></a>
                  </td>
                </tr>
                <br />
                <tr>
                  <td>
                    <Save_inquary product={"Contact"} />
                  </td>
                </tr>

              </table>
            </div>
          </div>
        </div>

      </div>
      <div className="tearms_body">
        <div className="container_size">
          <div className='post-container'>
            <div className='post_div'>
              <div className='ui-grid'>
                <div className='ui-items text-h3'>&#169; <b className='bold'>aooz.in</b> - {new Date().getFullYear()} All rights reserved</div>
                <div className='ui-items'>
                  <a className="tab-link text-h3" title='Terms and Conditions' href='/terms-and-conditions'>Terms and Conditions</a>
                  {" • "}
                  <a className="tab-link text-h3" title='Terms and Conditions' href='/privacy-policy'>privacy policy</a>


                </div>



                <div className='ui-items'>

                  <a className="tab-link text-h3" title='Terms and Conditions' href='/legal'>Legal</a>
                  {" • "}
                  <a className="tab-link text-h3" title='Terms and Conditions' href='/sitemap'>Sitemap</a>
                </div>

              </div> 
            </div>
            <div className="post_updates">
              <table>
                <tr className='p-3'>
                  <td>
                    <time className="tab-link text-h3 " dateTime="2026-03-01">
                      Update: 1 March 2026
                    </time>
                  </td>
                  <td width={120}>
                    <a className="tab-link  text-r text-h3 " href="https://aooz.in" _target >Product by: <b className='bold'>AOOZ</b></a>

                  </td>
                </tr>
              </table>


            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
